var _excluded = ["classNames", "checked", "onChange", "label"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import { cx } from 'instantsearch-ui-components';
import React from 'react';
export function ToggleRefinement(_ref) {
  var _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    checked = _ref.checked,
    _onChange = _ref.onChange,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('ais-ToggleRefinement', classNames.root, props.className)
  }), /*#__PURE__*/React.createElement("label", {
    className: cx('ais-ToggleRefinement-label', classNames.label)
  }, /*#__PURE__*/React.createElement("input", {
    className: cx('ais-ToggleRefinement-checkbox', classNames.checkbox),
    type: "checkbox",
    checked: checked,
    onChange: function onChange(event) {
      _onChange(event.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('ais-ToggleRefinement-labelText', classNames.labelText)
  }, label)));
}